import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@xo-union/tk-component-buttons';
import Icon from '@xo-union/tk-component-icons';
import styles from './styles.scss';

const ButtonDropdown = ({ size, color, text, className, children, ...rest }) => {
  const [showDrop, setShowDrop] = React.useState(false);
  const buttonRef = React.useRef();
  const dropdownRef = React.useRef();

  // NOTE: to close dropdown on click outside of the component
  const handleOutsideClick = e => {
    if (buttonRef.current.contains(e.target) || (dropdownRef.current && dropdownRef.current.contains(e.target))) {
      return;
    } else {
      setShowDrop(false);
    }
  };

  React.useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, []);

  return (
    <div className={styles.buttonDropdownContainer}>
      <Button
        ref={buttonRef}
        className={className}
        color={color}
        size={size}
        block
        onClick={() => setShowDrop(prev => !prev)}
        {...rest}
      >
        <div className={styles.buttonCenter}>
          {text}
          <Icon className={styles.arrowIcon} name="arrow_down" size="md" />
        </div>
      </Button>
      {showDrop && (
        <div ref={dropdownRef} className={styles.buttonDropdownList}>
          <ul className={styles.list}>
            {React.Children.map(children, child =>
              React.cloneElement(child, { closeDropdown: () => setShowDrop(false) })
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

ButtonDropdown.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.string,
  text: PropTypes.string,
};

export default ButtonDropdown;
